export default "__VITE_ASSET__C5VL6N5N__"